import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createOutlet } from "../services/business.js";

import {
    ArrowLeft,
    Store,
} from "lucide-react";

import { Header } from "./Header";
import { MobileHeader } from "./MobileHeader";

export function AddOutlet() {

    const navigate = useNavigate();

    const [outlet, setOutlet] = useState({

        outletName: "",

        addressLine1: "",

        addressLine2: "",

        city: "",

        state: "",

        pincode: "",

        contactNumber: "",

    });

    function updateField(field, value) {

        setOutlet(previous => ({

            ...previous,

            [field]: value,

        }));

    }

    async function handleSubmit(event) {

        event.preventDefault();

        try {

            const response = await createOutlet({

                outletName: outlet.outletName.trim(),

                addressLine1: outlet.addressLine1.trim(),

                addressLine2: outlet.addressLine2.trim(),

                city: outlet.city.trim(),

                state: outlet.state,

                pincode: outlet.pincode.trim(),

                contactNumber: outlet.contactNumber.trim(),

                isPrimary: false,

            });

            //--------------------------------------------------
            // Success
            //--------------------------------------------------

            console.log("Outlet created:", response);

            navigate("/overview");

        }

        catch (error) {

            console.error("Failed to create outlet:", error);

            alert(

                error.response?.data?.error ||

                error.message ||

                "Failed to create outlet."

            );

        }

    }

    return (

        <>

            <div className="create-offer-content">

                <MobileHeader />

                <main className="create-offer-page">

                    <Header

                        title="Add Outlet"

                        subtitle="Create a new outlet to manage offers, transactions and analytics separately."

                    />

                    <button

                        className="back-button"

                        onClick={() => navigate(-1)}

                    >

                        <ArrowLeft size={18} />

                        Back

                    </button>

                    <form
                        className="add-outlet-form"
                        onSubmit={handleSubmit}
                    >

                        <section className="add-outlet-card">

                            <div className="add-outlet-content">

                                <h2>

                                    <Store size={20} />

                                    Outlet Details

                                </h2>

                                <p className="add-outlet-description">

                                    Create a new outlet to manage offers, transactions and analytics separately.

                                </p>

                                <div className="add-outlet-divider" />

                                <div className="add-outlet-group">

                                    <label>

                                        Outlet Name

                                    </label>

                                    <input
                                        className="add-outlet-input"
                                        type="text"
                                        placeholder="Enter outlet name"
                                        value={outlet.outletName}
                                        onChange={(e) =>
                                            updateField(
                                                "outletName",
                                                e.target.value
                                            )
                                        }
                                        required
                                    />

                                </div>

                                <div className="add-outlet-group">

                                    <label>

                                        Address Line 1

                                    </label>

                                    <input
                                        className="add-outlet-input"
                                        type="text"
                                        placeholder="Enter address line 1"
                                        value={outlet.addressLine1}
                                        onChange={(e) =>
                                            updateField(
                                                "addressLine1",
                                                e.target.value
                                            )
                                        }
                                        required
                                    />

                                </div>

                                <div className="add-outlet-group">

                                    <label>

                                        Address Line 2

                                    </label>

                                    <input
                                        className="add-outlet-input"
                                        type="text"
                                        placeholder="Apartment, Suite, etc. (Optional)"
                                        value={outlet.addressLine2}
                                        onChange={(e) =>
                                            updateField(
                                                "addressLine2",
                                                e.target.value
                                            )
                                        }
                                    />

                                </div>

                                <div className="add-outlet-row">

                                    <div className="add-outlet-group">

                                        <label>

                                            City

                                        </label>

                                        <input
                                            className="add-outlet-input"
                                            type="text"
                                            placeholder="City"
                                            value={outlet.city}
                                            onChange={(e) =>
                                                updateField(
                                                    "city",
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />

                                    </div>

                                    <div className="add-outlet-group">

                                        <label>

                                            State

                                        </label>

                                        <select
                                            className="add-outlet-input"
                                            value={outlet.state}
                                            onChange={(e) =>
                                                updateField(
                                                    "state",
                                                    e.target.value
                                                )
                                            }
                                            required
                                        >

                                            <option value="">
                                                Select State / Union Territory
                                            </option>

                                            {/* States */}

                                            <option value="Andhra Pradesh">
                                                Andhra Pradesh
                                            </option>

                                            <option value="Arunachal Pradesh">
                                                Arunachal Pradesh
                                            </option>

                                            <option value="Assam">
                                                Assam
                                            </option>

                                            <option value="Bihar">
                                                Bihar
                                            </option>

                                            <option value="Chhattisgarh">
                                                Chhattisgarh
                                            </option>

                                            <option value="Goa">
                                                Goa
                                            </option>

                                            <option value="Gujarat">
                                                Gujarat
                                            </option>

                                            <option value="Haryana">
                                                Haryana
                                            </option>

                                            <option value="Himachal Pradesh">
                                                Himachal Pradesh
                                            </option>

                                            <option value="Jharkhand">
                                                Jharkhand
                                            </option>

                                            <option value="Karnataka">
                                                Karnataka
                                            </option>

                                            <option value="Kerala">
                                                Kerala
                                            </option>

                                            <option value="Madhya Pradesh">
                                                Madhya Pradesh
                                            </option>

                                            <option value="Maharashtra">
                                                Maharashtra
                                            </option>

                                            <option value="Manipur">
                                                Manipur
                                            </option>

                                            <option value="Meghalaya">
                                                Meghalaya
                                            </option>

                                            <option value="Mizoram">
                                                Mizoram
                                            </option>

                                            <option value="Nagaland">
                                                Nagaland
                                            </option>

                                            <option value="Odisha">
                                                Odisha
                                            </option>

                                            <option value="Punjab">
                                                Punjab
                                            </option>

                                            <option value="Rajasthan">
                                                Rajasthan
                                            </option>

                                            <option value="Sikkim">
                                                Sikkim
                                            </option>

                                            <option value="Tamil Nadu">
                                                Tamil Nadu
                                            </option>

                                            <option value="Telangana">
                                                Telangana
                                            </option>

                                            <option value="Tripura">
                                                Tripura
                                            </option>

                                            <option value="Uttar Pradesh">
                                                Uttar Pradesh
                                            </option>

                                            <option value="Uttarakhand">
                                                Uttarakhand
                                            </option>

                                            <option value="West Bengal">
                                                West Bengal
                                            </option>

                                            {/* Union Territories */}

                                            <option value="Andaman and Nicobar Islands">
                                                Andaman and Nicobar Islands
                                            </option>

                                            <option value="Chandigarh">
                                                Chandigarh
                                            </option>

                                            <option value="Dadra and Nagar Haveli and Daman and Diu">
                                                Dadra and Nagar Haveli and Daman and Diu
                                            </option>

                                            <option value="Delhi">
                                                Delhi
                                            </option>

                                            <option value="Jammu and Kashmir">
                                                Jammu and Kashmir
                                            </option>

                                            <option value="Ladakh">
                                                Ladakh
                                            </option>

                                            <option value="Lakshadweep">
                                                Lakshadweep
                                            </option>

                                            <option value="Puducherry">
                                                Puducherry
                                            </option>

                                        </select>

                                    </div>

                                </div>

                                <div className="add-outlet-row">

                                    <div className="add-outlet-group">

                                        <label>

                                            Pincode

                                        </label>

                                        <input
                                            className="add-outlet-input"
                                            type="text"
                                            placeholder="Pincode"
                                            value={outlet.pincode}
                                            onChange={(e) =>
                                                updateField(
                                                    "pincode",
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />

                                    </div>

                                    <div className="add-outlet-group">

                                        <label>

                                            Phone Number

                                        </label>

                                        <input
                                            className="add-outlet-input"
                                            type="tel"
                                            placeholder="Phone number"
                                            value={outlet.contactNumber}
                                            onChange={(e) =>
                                                updateField(
                                                    "contactNumber",
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />

                                    </div>

                                </div>

                                <div className="add-outlet-divider" />

                                <div className="add-outlet-footer">

                                    <button
                                        type="submit"
                                        className="primary-btn"
                                    >

                                        Continue

                                    </button>

                                </div>

                            </div>

                        </section>

                    </form>

                </main>

            </div>

        </>

    );

}